import * as React from "react";
import {
  DependentSelectionsModelProvider,
  DependentSelectionsProps,
  DSOption,
  DSOptionCollection,
  updateSelection,
} from "./DependentSelectionsModel";
import { ChoiceGroup, Dropdown, ResponsiveMode } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

const DependentSelectionsFluentUI: React.FunctionComponent<DependentSelectionsProps> = (props) => {
  return (
    <>
      {props.collections.map((col, collectionIndex) => {
        let customSelector: React.ReactNode | undefined = undefined;
        if (col.customSelector) {
          customSelector = col.customSelector(props);
        }

        if (customSelector) {
          return <div key={col.key + "_sel"}>{customSelector}</div>;
        }
        if (col.type === "radio") {
          return (
            <RadioCollectionFluentUI
              key={col.key + "_sel"}
              model={props}
              collection={col}
              collectionIndex={collectionIndex}
            />
          );
        }
        return (
          <SelectCollectionFluentUI
            key={col.key + "_sel"}
            model={props}
            collection={col}
            collectionIndex={collectionIndex}
          />
        );
      })}
    </>
  );
};

const SelectCollectionFluentUI: React.FunctionComponent<{
  model: DependentSelectionsModelProvider;
  collection: DSOptionCollection<DSOption>;
  collectionIndex: number;
}> = ({ model, collection, collectionIndex }) => {
  const selected = collectionIndex < model.selections.length ? model.selections[collectionIndex].key : "";

  return (
    <Dropdown
      data-testid={"dropdown"}
      id={collection.key}
      disabled={collection.disabled || collection.options == undefined}
      placeholder={formatMessage("cof.base.select")}
      label={collection.title}
      options={collection.options
        .filter((o) => (!collection.disabled ? !o.notSelectable : true))
        .map((o) => {
          return { key: o.key, text: o.label };
        })}
      required
      onChange={(_event, option) => updateSelection(model, collectionIndex, option?.key as string)}
      selectedKey={selected}
      responsiveMode={ResponsiveMode.large}
    />
  );
};

const RadioCollectionFluentUI: React.FunctionComponent<{
  model: DependentSelectionsModelProvider;
  collection: DSOptionCollection<DSOption>;
  collectionIndex: number;
}> = ({ model, collection, collectionIndex }) => {
  const selectedKey = collectionIndex < model.selections.length ? model.selections[collectionIndex].key : "";
  return (
    <ChoiceGroup
      styles={{ flexContainer: { display: "flex", columnGap: "10px" } }}
      selectedKey={selectedKey}
      id={collection.key}
      disabled={collection.disabled}
      options={collection.options.map((op) => {
        return { key: op.key, text: op.label, disabled: op.notSelectable, id: `${collection.key}_${op.key}` };
      })}
      onChange={(_, option) => updateSelection(model, collectionIndex, option?.key)}
    />
  );
};

export default DependentSelectionsFluentUI;
